import React from 'react';

export default class VideoPlayer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        this.init();
    }

    componentDidUpdate(prevProps) {
        if (this.props.url !== prevProps.url) {
            this.init();
        }
    }

    init = () => {
        if (!this.props.url) {
            return;
        }

        let embeded_url = '';

        if (this.props.url.includes('youtube.com')) {
            const code = this.props.url.match('(?:\\?|&|&amp;)v=(.+?)(?:&|$)')[1];
            embeded_url = `https://www.youtube.com/embed/${code
            }?wmode=transparent&autoplay=${this.props.autoplay}&hl=ru&rel=0&showinfo=0;`;
        } else if (this.props.url.includes('youtu.be')) {
            const code = this.props.url.split('youtu.be/')[1];
            embeded_url = `https://www.youtube.com/embed/${code}?wmode=transparent&autoplay=${this.props.autoplay
            }&hl=ru&rel=0&showinfo=0`;
        } else if (this.props.url.includes('video.mail.ru')) {
            const code = this.props.url.split('/').slice(3, 7).join('/');
            embeded_url = `https://videoapi.my.mail.ru/videos/embed/${code}`;
        } else if (this.props.url.includes('api.video.mail.ru') || this.props.url.includes('videoapi.my.mail.ru')) {
            embeded_url = this.props.url;
        } else if (this.props.url.includes('vk.com')) {
            embeded_url = this.props.url.includes('vk.com');
        } else if (this.props.url.includes('ok.ru')) {
            const code = this.props.url.split('/')[4];
            embeded_url = `https://ok.ru/videoembed/${code}`;
        } else if (this.props.url.includes('clips.twitch.tv')) {
            const split_lst = this.props.url.split('/');
            embeded_url = `https://clips.twitch.tv/embed?clip=${split_lst[split_lst.length - 1]
            }&autoplay=${this.props.autoplay}`;
        } else if (this.props.url.includes('twitch.tv')) {
            const split_lst = this.props.url.split('/');
            embeded_url = `https://player.twitch.tv/?channel=${split_lst[split_lst.length - 1]
            }&autoplay=${this.props.autoplay}`;
        } else if (this.props.url.includes('vimeo.com')) {
            const split_lst = this.props.url.split('/');
            embeded_url = `https://player.vimeo.com/video/${split_lst[split_lst.length - 1]}?color=ffffff`;
        } else if (this.props.url.includes('own3d.tv')) {
            // TODO: не удалось проверить работоспособность, нужен пример ссылки
            const split_lst = this.props.url.split('/');
            embeded_url = `https://www.own3d.tv/liveembed/${split_lst[split_lst.length - 1]}`;
        } else if (this.props.url.includes('coub.com')) {
            const split_lst = this.props.url.split('/');
            embeded_url = `https://coub.com/embed/${split_lst[split_lst.length - 1]}?muted=false&autostart=${
                this.props.autoplay}`;
        }

        this.setState({ embeded_url });
    };

    render() {
        return (
            <iframe
                title={`video_${this.state.embeded_url}`}
                width="500px"
                height="300px"
                src={this.state.embeded_url}
                frameBorder="0"
                scrolling="no"
                allowFullScreen
            />

        );
    }
}
